import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter,
} from "../components/ui/dialog";
import { Plus, Trash2, Building2, Mail, Phone } from "lucide-react";

export default function Clients() {
  const [clients, setClients] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", company: "", email: "", phone: "" });

  const load = () => api.get("/clients").then((r) => setClients(r.data));
  useEffect(() => { load(); }, []);

  const upd = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const create = async () => {
    if (!form.name.trim()) return toast.error("Le nom est requis");
    await api.post("/clients", form);
    toast.success("Client ajouté");
    setForm({ name: "", company: "", email: "", phone: "" });
    setOpen(false);
    load();
  };

  const remove = async (id) => {
    await api.delete(`/clients/${id}`);
    toast.success("Client supprimé");
    load();
  };

  return (
    <div className="p-6 md:p-8 lg:p-12 max-w-7xl">
      <div className="flex flex-wrap items-end justify-between gap-4 mb-8">
        <div>
          <p className="text-xs tracking-[0.2em] uppercase font-semibold text-muted-foreground mb-2">Carnet</p>
          <h1 className="font-heading text-3xl lg:text-4xl font-bold tracking-tight">Clients</h1>
        </div>
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild>
            <Button data-testid="add-client-button" className="h-11 rounded-sm bg-primary hover:bg-primary/90 font-semibold">
              <Plus className="w-4 h-4 mr-1" /> Ajouter un client
            </Button>
          </DialogTrigger>
          <DialogContent className="rounded-sm">
            <DialogHeader><DialogTitle className="font-heading">Nouveau client</DialogTitle></DialogHeader>
            <div className="space-y-4 py-2">
              <div><Label>Nom du contact *</Label><Input value={form.name} onChange={upd("name")} data-testid="client-name-input" className="mt-1.5 rounded-sm" placeholder="Marie Martin" /></div>
              <div><Label>Entreprise</Label><Input value={form.company} onChange={upd("company")} data-testid="client-company-input" className="mt-1.5 rounded-sm" placeholder="Acme SAS" /></div>
              <div><Label>Email</Label><Input value={form.email} onChange={upd("email")} type="email" className="mt-1.5 rounded-sm" placeholder="marie@acme.fr" /></div>
              <div><Label>Téléphone</Label><Input value={form.phone} onChange={upd("phone")} className="mt-1.5 rounded-sm" placeholder="01 23 45 67 89" /></div>
            </div>
            <DialogFooter>
              <Button onClick={create} data-testid="save-client-button" className="rounded-sm bg-primary hover:bg-primary/90">Enregistrer</Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      </div>

      {clients.length === 0 ? (
        <div className="bg-card border border-border rounded-sm px-6 py-16 text-center text-muted-foreground" data-testid="empty-clients">
          Aucun client enregistré pour l'instant.
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {clients.map((c) => (
            <div key={c.id} data-testid={`client-${c.id}`}
              className="bg-card border border-border rounded-sm p-5 transition-all duration-200 hover:border-primary/50">
              <div className="flex items-start justify-between">
                <div className="w-10 h-10 rounded-sm bg-primary/10 text-primary flex items-center justify-center font-heading font-bold">
                  {c.name.charAt(0).toUpperCase()}
                </div>
                <button onClick={() => remove(c.id)} data-testid={`delete-client-${c.id}`} className="text-muted-foreground hover:text-destructive transition-colors">
                  <Trash2 className="w-4 h-4" />
                </button>
              </div>
              <p className="font-heading font-semibold mt-3">{c.name}</p>
              {c.company && <p className="text-sm text-muted-foreground flex items-center gap-1.5 mt-2"><Building2 className="w-3.5 h-3.5" /> {c.company}</p>}
              {c.email && <p className="text-sm text-muted-foreground flex items-center gap-1.5 mt-1"><Mail className="w-3.5 h-3.5" /> {c.email}</p>}
              {c.phone && <p className="text-sm text-muted-foreground flex items-center gap-1.5 mt-1"><Phone className="w-3.5 h-3.5" /> {c.phone}</p>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
